//#region IMPORT
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';

import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { FormControlLabel, Switch } from '@mui/material';
import { getColumnDefs1 } from './BUD_BASIC_01_ColumnDefs';

const GetCategoryGroupKey = (row) =>
  String(row?.categoryName ?? '').trim().toLowerCase();

function BUD_BASIC_01(props) {
  const dispatch = useDispatch();

  // 합계 행 계산 (구분별 합계 행들의 합산)
  const pinnedBottomRowData = useMemo(() => {
    if (!props.rowData1 || props.rowData1.length === 0) return [];

    // 구분별 합계 행들만 필터링 (isSummaryRow가 true인 행들)
    const summaryRows = props.rowData1.filter((row) => row.isSummaryRow);

    if (summaryRows.length === 0) return [];

    // 연간예산 총액의 합계 (구분별 합계 행들의 합산)
    const totalYearPlanAmount = summaryRows.reduce(
      (sum, row) => sum + (parseFloat(row.currentYearPlanAmount) || 0),
      0
    );
    // 합계의 총합 (구분별 합계 행들의 합산)
    const totalYearAmount = summaryRows.reduce(
      (sum, row) => sum + (parseFloat(row.totalYearAmount) || 0),
      0
    );
    // 예산대비집행실적: 합계의 총합 / 연간예산 총액의 합계 (소수점 둘째자리까지)
    const execVsPlanRate =
      totalYearPlanAmount !== 0
        ? parseFloat((totalYearAmount / totalYearPlanAmount).toFixed(2))
        : 0;

    const summary = {
      no: '합계',
      categoryName: '합계',
      itemName: '',
      currentYearPlanAmount: totalYearPlanAmount,
      month01: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month01) || 0),
        0
      ),
      month02: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month02) || 0),
        0
      ),
      month03: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month03) || 0),
        0
      ),
      month04: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month04) || 0),
        0
      ),
      month05: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month05) || 0),
        0
      ),
      month06: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month06) || 0),
        0
      ),
      month07: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month07) || 0),
        0
      ),
      month08: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month08) || 0),
        0
      ),
      month09: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month09) || 0),
        0
      ),
      month10: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month10) || 0),
        0
      ),
      month11: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month11) || 0),
        0
      ),
      month12: summaryRows.reduce(
        (sum, row) => sum + (parseFloat(row.month12) || 0),
        0
      ),
      totalYearAmount: totalYearAmount,
      execVsPlanRate: execVsPlanRate,
      remark: '',
    };

    return [summary];
  }, [props.rowData1]);

  const columnDefs1 = useMemo(() => getColumnDefs1(props), [
    props.viewMode,
    props.rowData1,
    props.gridRef1,
  ]);

  // 합계 행 스타일 함수
  const getRowStyle = (params) => {
    // 구분별 합계 행 (연한 녹색)
    if (params.data?.isSummaryRow) {
      return { backgroundColor: '#e8f5e9' };
    }
    // 최종 합계 행 (연한 파란색)
    if (params.data?.no === '합계') {
      return { backgroundColor: '#e3f2fd' };
    }
    return null;
  };

  //#endregion
  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => String(params.data?.no ?? '')}
        gridRef={props.gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1 || []}
        setChangedRowData={props.setChangedRowData1}
        setSelectedRowData={props.setSelectedRowData1}
        animateRows={false}
        suppressColumnVirtualisation={true}
        flex={1}
        title1="안전보건관리결산(집행내역)"
        deleteYn1="Y"
        addYn1="Y"
        rowSelection={'multiple'}
        suppressRowClickSelection={true}
        pinnedBottomRowData={pinnedBottomRowData}
        getRowStyle={getRowStyle}
        addClick1={async () => {
          if (!props.validateSelection()) return;

          const defaults = props.BuildDefaultNewBudgetRow1?.() ?? {};
          GridFunctions.addClick(props.gridRef1, defaults);
        }}
        deleteClick1={() => {
          if (!props.validateSelection()) return;

          // 합계 행은 삭제 대상에서 제외 (합계 행이 섞여 선택돼도 나머지 행은 삭제 가능하도록)
          const sel = (props.selectedRowData1 || []).filter(
            (r) => !r.isSummaryRow && r.no !== '합계'
          );
          if (!sel.length) {
            dispatch(
              showSnackbar({
                message: '삭제할 행을 선택하세요.',
                type: 'warning',
              })
            );
            return;
          }
          const allNew = sel.every((r) => r.newYn === 'Y');
          const anyNew = sel.some((r) => r.newYn === 'Y');
          if (allNew) {
            sel.forEach((r) => props.DeleteNewRow1?.(r));
            return;
          }
          if (anyNew) {
            dispatch(
              showSnackbar({
                message:
                  '신규 행과 기존 행을 함께 삭제할 수 없습니다. 각각 선택해 주세요.',
                type: 'warning',
              })
            );
            return;
          }
          props.MarkedForDeletion1?.(sel);
        }}
        fileUploadYn1="Y"
        fileUploadClick1={() => {
          if (!props.validateSelection()) return;
          props.fileInputRef?.current?.click();
        }}
        fileDownloadYn1="Y"
        fileDownloadClick1={() => {
          if (!props.validateSelection()) return;
          props.ExcelDownload1();
        }}
        onCellValueChanged={(e) => {
          // 합계 행이면 처리하지 않음
          if (e.data.isSummaryRow) {
            return;
          }

          // ag-Grid-functions.js 패턴: 모든 노드 데이터 가져오기
          let defaultData = [];
          props.gridRef1?.current?.api.forEachNode((node) => {
            defaultData.push({ ...node.data, i: node.id });
          });

          // 변경된 행 찾기
          const changeRow = defaultData.filter((f) => f.i === e.node.id)[0];
          const changeRow2 =
            props.gridRef1?.current?.api.getDisplayedRowAtIndex(e.rowIndex);

          if (!changeRow) return;

          // 월별 합계 및 집행률 실시간 계산
          const monthFields = [
            'month01',
            'month02',
            'month03',
            'month04',
            'month05',
            'month06',
            'month07',
            'month08',
            'month09',
            'month10',
            'month11',
            'month12',
          ];

          const totalYearAmount = monthFields.reduce((sum, field) => {
            const v = changeRow[field];
            const num =
              typeof v === 'number' ? v : v != null && v !== '' ? Number(v) : 0;
            return sum + (isNaN(num) ? 0 : num);
          }, 0);

          const plan =
            typeof changeRow.currentYearPlanAmount === 'number'
              ? changeRow.currentYearPlanAmount
              : changeRow.currentYearPlanAmount != null &&
                changeRow.currentYearPlanAmount !== ''
                ? Number(changeRow.currentYearPlanAmount)
                : 0;

          const updatedRow = {
            ...changeRow,
            totalYearAmount: totalYearAmount,
            execVsPlanRate:
              plan > 0
                ? parseFloat(((totalYearAmount / plan) * 100).toFixed(2))
                : 0,
            editYn: 'Y',
          };

          // ag-Grid-functions.js 패턴: setChangedRowData1에 넣기
          if (props.setChangedRowData1) {
            props.setChangedRowData1((current = []) => {
              const idx = current.findIndex((c) => c.no === updatedRow.no);
              if (idx > -1) {
                const next = [...current];
                next[idx] = updatedRow;
                return next;
              } else {
                return [...current, updatedRow];
              }
            });
          }

          // 그리드 노드 업데이트
          if (changeRow2) {
            changeRow2.setData(updatedRow);
            props.gridRef1?.current?.api.flashCells({
              rowNodes: [changeRow2],
            });
          }

          // 원본 rowData 갱신 (그리드 실제 데이터 기준으로 동기화)
          if (props.setRowData1) {
            const newRowData = defaultData.map(({ i, ...row }) =>
              row.no === updatedRow.no ? updatedRow : row
            );

            // 해당 그룹의 합계 행 자동 업데이트
            const categoryGroupKey = GetCategoryGroupKey(updatedRow);
            if (categoryGroupKey) {
              // 같은 categoryName 그룹의 일반 행들 찾기 (합계 행 제외)
              const groupItems = newRowData.filter(
                (row) =>
                  !row.isSummaryRow &&
                  GetCategoryGroupKey(row) === categoryGroupKey
              );

              // 합계 행 찾기
              const summaryRowIndex = newRowData.findIndex(
                (row) =>
                  row.isSummaryRow && row.groupCategoryName === categoryGroupKey
              );

              if (summaryRowIndex !== -1 && groupItems.length > 0) {
                // 그룹별 합계 계산
                const groupTotalYearPlanAmount = groupItems.reduce(
                  (sum, row) =>
                    sum + (parseFloat(row.currentYearPlanAmount) || 0),
                  0
                );

                const groupMonthTotals = {};
                monthFields.forEach((field) => {
                  groupMonthTotals[field] = groupItems.reduce(
                    (sum, row) => sum + (parseFloat(row[field]) || 0),
                    0
                  );
                });

                const groupTotalYearAmount = Object.values(
                  groupMonthTotals
                ).reduce((sum, val) => sum + val, 0);

                const groupExecVsPlanRate =
                  groupTotalYearPlanAmount > 0
                    ? parseFloat(
                      (
                        (groupTotalYearAmount / groupTotalYearPlanAmount) *
                        100
                      ).toFixed(2)
                    )
                    : 0;

                // 합계 행 업데이트
                const updatedSummaryRow = {
                  ...newRowData[summaryRowIndex],
                  groupCategoryName: categoryGroupKey,
                  currentYearPlanAmount: groupTotalYearPlanAmount,
                  ...groupMonthTotals,
                  totalYearAmount: groupTotalYearAmount,
                  execVsPlanRate: groupExecVsPlanRate,
                };

                newRowData[summaryRowIndex] = updatedSummaryRow;
                props.setRowData1(newRowData);

                // 그리드에서 합계 행 업데이트
                const gridApi = props.gridRef1?.current?.api;
                if (gridApi) {
                  gridApi.forEachNode((node) => {
                    if (
                      node.data?.isSummaryRow &&
                      node.data?.groupCategoryName === categoryGroupKey
                    ) {
                      node.setData(updatedSummaryRow);
                    }
                  });
                }
              } else {
                props.setRowData1(newRowData);
              }
            } else {
              props.setRowData1(newRowData);
            }
          }
        }}
        onCellKeyDown={(params) => {
          // Tab 키를 눌렀을 때 다음 편집 가능한 셀로 이동
          if (params.event.key === 'Tab' && !params.event.shiftKey) {
            const currentRowIndex = params.rowIndex;
            const currentColId = params.column.getColId();

            // 편집 가능한 컬럼 필드 목록 (순서대로)
            const editableFields = [
              'categoryName',
              'itemName',
              'month01',
              'month02',
              'month03',
              'month04',
              'month05',
              'month06',
              'month07',
              'month08',
              'month09',
              'month10',
              'month11',
              'month12',
              'remark',
            ];

            const currentIndex = editableFields.indexOf(currentColId);

            if (currentIndex >= 0 && currentIndex < editableFields.length - 1) {
              // 같은 행의 다음 편집 가능한 컬럼으로 이동
              const nextColKey = editableFields[currentIndex + 1];
              params.api.setFocusedCell(currentRowIndex, nextColKey);
              params.api.startEditingCell({
                rowIndex: currentRowIndex,
                colKey: nextColKey,
              });
              params.event.preventDefault();
            } else if (currentIndex === editableFields.length - 1) {
              // 마지막 컬럼이면 다음 행의 첫 번째 편집 가능한 컬럼으로 이동
              const nextRowIndex = currentRowIndex + 1;
              const rowCount = params.api.getDisplayedRowCount();
              if (nextRowIndex < rowCount) {
                const firstColKey = editableFields[0];
                params.api.setFocusedCell(nextRowIndex, firstColKey);
                params.api.startEditingCell({
                  rowIndex: nextRowIndex,
                  colKey: firstColKey,
                });
                params.event.preventDefault();
              }
            }
          }
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          if (props.SearchLogic1) {
            props.SearchLogic1();
          }
        }}
        other1={
          <div style={{ marginLeft: '12px', display: 'inline-flex' }}>
            <FormControlLabel
              control={
                <Switch
                  checked={props.viewMode === 'quarter'}
                  onChange={props.handleToggleView}
                  color="primary"
                />
              }
              label={props.viewMode === 'half' ? '반기' : '분기'}
            />
          </div>
        }
      />
      {/* 엑셀 업로드용 숨김 파일 input */}
      <input
        type="file"
        ref={props.fileInputRef}
        style={{ display: 'none' }}
        accept=".xlsx,.xls"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            props.ExcelUpload1(file);
            // 같은 파일을 다시 선택할 수 있도록 초기화
            e.target.value = '';
          }
        }}
      />
    </React.Fragment>
  );
}

export default BUD_BASIC_01;
